module.exports = __webpack_public_path__ + "static/vecera-4862909557a8d139aba1e29c6add721f.jpg";